import { Link } from "react-router-dom";
import Logo from "./Logo";

const cols = [
  {
    title: "Explore",
    links: [
      { to: "/story", label: "Enter Through Story" },
      { to: "/nations", label: "For Nations" },
      { to: "/design", label: "Girribal Learning" },
      { to: "/architecture", label: "Lore-Led Architecture" },
      { to: "/assurance", label: "Community Responsibility" },
    ],
  },
  {
    title: "Engage",
    links: [
      { to: "/pricing", label: "Licensing" },
      { to: "/readiness", label: "Readiness Assessment" },
      { to: "/capability-statement", label: "Capability Statement" },
      { to: "/contact", label: "Request Access" },
    ],
  },
  {
    title: "Legal",
    links: [
      { to: "/legal/privacy", label: "Privacy Notice" },
      { to: "/legal/terms", label: "Terms of Use" },
      { to: "/legal/icip", label: "Cultural & ICIP Notice" },
      { to: "/legal/background-ip", label: "Background IP Notice" },
      { to: "/privacy-preferences", label: "Privacy Preferences" },
    ],
  },
];

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-stone-200 bg-stone-50 mt-24">
      <div className="mx-auto max-w-[1400px] px-6 md:px-10 lg:px-16 py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-4">
            <Logo />
            <p className="mt-5 text-sm text-stone-600 leading-relaxed max-w-sm">
              Aboriginal Governance Architecture. Lore-Led Architecture™, Bigibila Advisory Method™ and Aboriginal Governance Architecture Model™.
            </p>
            <p className="mt-4 text-xs text-stone-500 leading-relaxed max-w-sm">
              Strong Foundations · Living Governance · Sovereign Futures.
            </p>
            <div className="mt-6 pt-5 border-t border-stone-200 max-w-sm">
              <div className="text-[10px] tracking-[0.24em] uppercase font-bold text-stone-500 mb-2">Country</div>
              <p className="text-xs text-stone-600 leading-relaxed">
                We acknowledge the Traditional Custodians of the lands on which we work, and we honour Elders past, present and emerging.
              </p>
            </div>
          </div>
          {cols.map((c) => (
            <div key={c.title} className="md:col-span-2">
              <div className="text-[10px] tracking-[0.24em] uppercase font-bold text-stone-500 mb-4">
                {c.title}
              </div>
              <ul className="space-y-2.5">
                {c.links.map((l) => (
                  <li key={l.to}>
                    <Link
                      to={l.to}
                      data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, '-')}`}
                      className="text-sm text-stone-700 hover:text-stone-900 hover:underline underline-offset-4 transition-colors"
                    >
                      {l.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-14 pt-8 border-t border-stone-200">
          <div className="text-[10px] tracking-[0.24em] uppercase font-bold text-stone-500 mb-3">
            Protective notice
          </div>
          <p className="text-sm text-stone-600 leading-relaxed max-w-4xl">
            BIGIBILA SYSTEMS™ is governance architecture for authority, permission, protection, accountability and evidence. It is <span className="text-stone-900 font-semibold">not</span> a database of culture, and it does <span className="text-stone-900 font-semibold">not</span> replace Aboriginal authority, community protocol, or legal advice. All material shown on this site is demonstration data only. Background IP notices apply. Communities are encouraged to build and test privately before publishing anything publicly. Any sensitive material remains under the custody and authority of its rightful holders.
          </p>
        </div>

        <div className="mt-10 flex flex-col md:flex-row md:items-center md:justify-between gap-3 text-xs text-stone-500">
          <div>© {new Date().getFullYear()} BIGIBILA SYSTEMS™ · Bigibila Consultancy. All rights reserved.</div>
          <div className="flex flex-wrap gap-x-5 gap-y-2">
            <Link to="/assurance" className="hover:text-stone-900">Safety</Link>
            <Link to="/story" className="hover:text-stone-900">Story</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
